module.exports = __webpack_public_path__ + "static/img/v21ThreeBg-p.b31f756.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v21ThreeBg-p.png
// module id = RyVh
// module chunks = 1